import type { components } from "@dolfin/api-admin";

type CountrySummary = components["schemas"]["CountryBankProfileSummary"];
type Currency = components["schemas"]["CurrencyResponse"];

// "United Kingdom (GB)" from an ISO code, falling back to the code.
export function formatCountryName(
  code: string | null | undefined,
  countries: CountrySummary[],
): string {
  if (!code) return "";
  const match = countries.find((c) => c.countryCode.toUpperCase() === code.toUpperCase());
  return match ? `${match.countryName} (${match.countryCode})` : code;
}

// "Pound Sterling (GBP)" from a bare ISO code. Not to be confused with `formatCurrency` in
// `@/lib/format`, which formats a money amount.
export function formatCurrencyName(
  code: string | null | undefined,
  currencies: Currency[],
): string {
  if (!code) return "";
  const match = currencies.find((c) => c.code.toUpperCase() === code.toUpperCase());
  return match ? `${match.name} (${match.code})` : code;
}
